var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"AddBlockButton",style:(_vm.cssVars),on:{"click":_vm.onClick}},[_vm._m(0),_vm._t("default")],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"AddBlockButton-Button"},[_c('i',{staticClass:"AddBlockButton-Icon fas fa-plus"})])
}]

export { render, staticRenderFns }